module.exports = __webpack_public_path__ + "fonts/Nunito-Medium.108670f0.ttf";